export const fetchPellets = resp => {
  return {
    type: "FETCH_PELLETS",
    payload: resp
  };
};

export const fetchInfinitePellets = resp => {
  return {
    type: "FETCH_INFINITE_PELLETS",
    payload: resp
  };
};

export const setPelletSelectedOrg = org => {
  return {
    type: "SET_PELLET_SELECTED_ORG",
    org
  };
};

export const resetPelletSelectedOrg = () => {
  return {
    type: "RESET_PELLET_SELECTED_ORG"
  };
};

export const savePelletsStateToCache = () => ({
  type: "SAVE_PELLETS_STATE_TO_CACHE"
});

export const restorePelletsStateFromCache = () => ({
  type: "RESTORE_PELLETS_STATE_FROM_CACHE"
});



// WEBPACK FOOTER //
// ./src/actions/actions/pellet.js